import { useState, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Axios from "axios";
import { toast } from "react-toastify";
//toastify css..
import "react-toastify/dist/ReactToastify.css";
import "../../App.css";
import { UserContext } from "../../context/UserContext";

const Login = () => {
  const { dispatch } = useContext(UserContext);
  const navigate = useNavigate();

  const [userL, setUserL] = useState({
    email: "",
    password: "",
  });

  let name, value;
  const userInputFn = (event) => {
    name = event.target.name;
    value = event.target.value;

    setUserL({ ...userL, [name]: value });
  };

  const loginFunc = async (e) => {
    try {
      e.preventDefault();

      const config = {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      };

      //remember curly braces solved the - iterable error
      const { email, password } = userL;
      const res = await Axios.post(
        "https://blogappserver-8sw1.onrender.com/login",
        {
          email,
          password,
        },
        config
      );
      const { data } = res;

      if (res.status === 400 || !data) {
        toast("Invalid Credential..!!", { type: "error" });
      } else {
        localStorage.setItem("email", email);
        localStorage.setItem("user", JSON.stringify(data.user));
        dispatch({ type: "USER", payload: data.user });
        toast("Login Successfully..!!", { type: "success" });
        navigate("/articles");
        window.location.reload(false);
      }
    } catch (error) {
      toast("Invalid Credential..!!", { type: "error" });
    }
  };

  return (
    <>
      {/* <div className="container">
        <h2 className="header">Get Started..!!</h2>

        <form method="POST">
          <br />
          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={userL.email}
              onChange={userInputFn}
              className="form-control"
            />
          </div>

          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              name="password"
              id="password"
              value={userL.password}
              onChange={userInputFn}
              className="form-control"
            />
          </div>

          <div className="d-flex justify-content-center">
            <button
              type="submit"
              value="Login"
              onClick={loginFunc}
              className="btn btn-primary btn-lg button"
            >
              Login
            </button>
          </div>
          <p className="text-center text-muted mt-3 pb-4">
            Don't have an account?
            <NavLink to="/register" className="fw-bold text-body">
              <u> Register here</u>
            </NavLink>
          </p>
        </form>
      </div> */}
      <div className="container bg-white">
        <div className="row justify-content-center mt-5">
          <div className="col-md-6">
            <div className="card border border-1">
              <div className="card-body">
                <h2 className="card-title text-center">Get Started</h2>

                <form method="POST">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={userL.email}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      value={userL.password}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      value="Login"
                      onClick={loginFunc}
                      className="btn btn-primary btn-lg"
                    >
                      Login
                    </button>
                  </div>

                  <p className="text-center text-muted mt-3">
                    Don't have an account?{" "}
                    <NavLink to="/register" className="fw-bold text-body">
                      <u>Register here</u>
                    </NavLink>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
